import angular from 'angular';
import moment from 'moment';
import guid from '@/shared/utils/guid';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import DocumentService from '@/shared/services/DocumentService';

angular
  .module('cloudX')
  .controller('FiscalVehicleDialog', [
    '$http',
    'appUrls',
    'flySvc',
    'checkSecurity',
    '$element',
    'close',
    'relationId',
    'data',
    'documents',
    fiscalVehicleDialog,
  ]);

function fiscalVehicleDialog(
  $http,
  appUrls,
  flySvc,
  checkSecurity,
  $element,
  close,
  relationId,
  data,
  documents,
) {
  var vm = this;
  vm.saving = false;
  vm.readOnly = !checkSecurity('Relation:u');
  vm.showValidation = false;
  vm.datepickerOptions = {
    startingDay: 1,
    initDate: moment
      .utc()
      .startOf('day')
      .toDate(),
  };
  vm.relationId = relationId;
  vm.documentsAccessor = {};
  vm.documentLinkType = 11;
  vm.documents = [...(documents || [])];
  vm.documentsChanged = false;
  vm.onDocumentsChanged = function() {
    vm.documentsChanged = true;
  };
  vm.vehicle = angular.extend(
    {
      relationId: relationId,
      type: 1,
      fuelType: null,
      brandAndModel: null,
      purchaseDate: null,
      saleDate: null,
      firstRegistrationDate: null,
      licensePlate: null,
      co2: null,
      co2WLTP: null,
      catalogValue: null,
      purchaseValue: null,
      professionalUsePercentage: null,
      vatDeductionPercentage: null,
      remark: null,
      endUser: null,
    },
    data,
  );
  vm.endUser = {
    relation: vm.vehicle.endUser,
    text: vm.vehicle.endUserName,
  };

  vm.endUserChanged = function() {
    const { relation = null, text = null } = vm.endUser || {};

    vm.vehicle.endUser = relation;
    vm.vehicle.endUserName = text;
  };

  vm.isValid = function() {
    if (!vm.form) return false;
    if (vm.form.$invalid) return false;
    if (vm.vehicle.endUser && !vm.vehicle.endUser.id) return false;

    return true;
  };

  vm.save = function() {
    if (!vm.isValid()) return '';
    if (vm.saving) return '';

    vm.saving = true;
    $http.post(`${appUrls.api}/api/Fiscal/Vehicle`, vm.vehicle).then(
      function({ data }) {
        if (typeof data.purchaseDate === 'string')
          data.purchaseDate = moment.utc(data.purchaseDate.substr(0, 10)).toDate();
        if (typeof data.saleDate === 'string')
          data.saleDate = moment.utc(data.saleDate.substr(0, 10)).toDate();
        if (typeof data.firstRegistrationDate === 'string')
          data.firstRegistrationDate = moment
            .utc(data.firstRegistrationDate.substr(0, 10))
            .toDate();

        if (data.id) {
          vm.vehicle.id = data.id;
          if (vm.documentsAccessor && vm.documentsAccessor.uploadNewDocuments) {
            return vm.documentsAccessor.uploadNewDocuments(data.id).then(changed => {
              vm.saving = false;
              flySvc.success();

              close([data, changed || vm.documentsChanged ? vm.documents : null], 500);
              $element.modal('hide');
            });
          }
        }
        vm.saving = false;
        flySvc.success();

        close([data, vm.documentsChanged ? vm.documents : null], 500);
        $element.modal('hide');
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error);
        return '';
      },
    );
  };
  vm.cancel = function() {
    close([null, vm.documentsChanged ? vm.documents : null], 500);
  };
}
